import React from "react";
import CookiePolicyScript from "../../components/CookiePolicyScript";
import {Image, View, Flex, useTheme, Grid} from "@aws-amplify/ui-react";
import coachingLogoWhite from '../../assets/images/logo/logo-white.svg';
import styles from "./index.module.css";
import Footer from "../../components/NoAuth/Footer";


export default function CookiePolicy() {
  const {tokens} = useTheme();

  const mainFlexClassNames = ["auth-wrapper", styles.mainFlex];

  return (
    <Flex
      direction="row"
      justifyContent="center"
      className={mainFlexClassNames.join(" ")}
    >
      <View
        className={styles.contentView}
      >
        {/*header logo*/}
        <View textAlign="center" padding={tokens.space.large}>
          <Image
            alt="Myedu logo"
            src={coachingLogoWhite}
          />
        </View>


        <View className={styles.registerWrapper}>
          <Grid
            templateColumns={{base: "1fr", medium: "2fr 1fr", large: "4fr 1fr"}}
            templateRows={{base: "repeat(5, auto)", medium: "repeat(4, auto"}}
            className={styles.mainGrid}
          >
            <View
              className={styles.titleViewWrapper}
              columnSpan={[1, 1, 2, 2]}
            >
              <CookiePolicyScript />
            </View>
          </Grid>
        </View>

        {/*footer text*/}
        <Footer />
      </View>
    </Flex>
  );
}